<template>
  <div class="tw:flex tw:justify-between tw:items-center tw:flex-row tw:w-full tw:py-5 tw:gap-x-4">
    <div class="tw:flex tw:flex-col">
      <h1 class="tw:md:text-header-big tw:font-bold tw:mb-2 tw:md:mb-3">{{ $t('tbs_welcome_banner') }}</h1>
      <p class="tw:md:text-base tw:text-sm">
        {{ $t('tbs_welcome_banner_subtext') }}
      </p>
    </div>
    <div class="tw:mx-auto">
      <img
        :src="BannerImage"
        alt="Business Studio"
        class="tw:min-w-[150px] tw:md:min-w-[200px] tw:h-[100px] tw:md:h-[133px]"
      />
    </div>
  </div>
</template>
<script setup>
const BannerImage = new URL('/src/assets/img/homepage/top-banner-img.png', import.meta.url)
</script>
